export default "__VITE_ASSET__CI8ZIQ7V__"